import Repository from '@/libs/axios'

const resource = '/admin/saved-filters'

export default {
  list(screen) {
    return Repository.get(`${resource}?screen=${screen}`)
  },
  save(payload) {
    return Repository.post(`${resource}`, payload)
  },
  update(id, payload) {
    return Repository.put(`${resource}/${id}`, payload)
  },
  delete(id) {
    return Repository.delete(`${resource}/${id}`)
  },
  setDefault(id, payload) {
    return Repository.patch(`${resource}/${id}/set-default`, payload)
  },
}
